/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustamount2Inputs */

const zh_adminsubs_adjustamount2 = /** @type {(inputs: Adminsubs_Adjustamount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

const en_adminsubs_adjustamount2 = /** @type {(inputs: Adminsubs_Adjustamount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const es_adminsubs_adjustamount2 = /** @type {(inputs: Adminsubs_Adjustamount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Adminsubs_Adjustamount2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustamount2 = /** @type {((inputs?: Adminsubs_Adjustamount2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustamount2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustamount2(inputs)
	if (locale === "en") return en_adminsubs_adjustamount2(inputs)
	return es_adminsubs_adjustamount2(inputs)
});
export { adminsubs_adjustamount2 as "adminSubs_adjustAmount" }